import { useEffect, useCallback } from 'react';
import { useGetNotificationsQuery, useMarkAsReadMutation, useMarkAllAsReadMutation } from '@/store/api/notificationsApi';
import { useWebSocket } from './useWebSocket';

export function useNotifications() {
  const { data, refetch, isLoading } = useGetNotificationsQuery({ limit: 20 });
  const [markRead] = useMarkAsReadMutation();
  const [markAllRead] = useMarkAllAsReadMutation();
  const { on } = useWebSocket({ namespace: '/notifications' });

  useEffect(() => {
    const unsubscribe = on('notification', () => {
      refetch();
    });
    return unsubscribe;
  }, [on, refetch]);

  const markAsRead = useCallback(
    async (id: string) => {
      await markRead(id).unwrap();
    },
    [markRead]
  );

  const markAllAsRead = useCallback(async () => {
    await markAllRead().unwrap();
  }, [markAllRead]);

  return {
    notifications: data?.data ?? [],
    unreadCount: data?.unreadCount ?? 0,
    isLoading,
    markAsRead,
    markAllAsRead,
    refetch,
  };
}
